const defaultIsDevBuild = process.env.NODE_ENV !== "production";
const noop = () => {};

export const createDevConsole = (enabled = defaultIsDevBuild) => {
  if (!enabled) {
    return {
      log: noop,
      warn: noop,
      error: noop,
      debug: noop,
      trace: noop,
    };
  }

  return {
    log: (...args) => globalThis.console.log(...args),
    warn: (...args) => globalThis.console.warn(...args),
    error: (...args) => globalThis.console.error(...args),
    debug: (...args) => globalThis.console.debug(...args),
    trace: (...args) => globalThis.console.trace(...args),
  };
};
